import Button from "../../components/buttons/button";
import { FiAlertTriangle } from "react-icons/fi";

const DeleteActivity = ({ t, selected, setOpen }) => {
  return (
    <div className="space-y-4">
      <span className="grid rounded-full w-11 mx-auto  size-11 place-content-center bg-[#FFEEEC]">
        <FiAlertTriangle size={28} className="text-[#FF0000]" />
      </span>
      <p className="text-xl font-bold text-center">{t("areUSureToDeleteActivity")}</p>
      <div className="flex flex-col items-center justify-center gap-4 p-4 border rounded-xl border-primary bg-sideBar">
        <div>
          <h4 className="font-medium">دورة كاراتيه</h4>
          <p className="font-medium text-mainGray">20/06/2025</p>
        </div>
        <p className="font-medium text-primary">
          تنبيه: هناك 18 عضو مسجل في هذا النشاط.
        </p>
      </div>
      <div className="flex items-center justify-center gap-2">
        <Button
          className={"bg-[#902929]"}
          type={"button"}
          onClick={() => setOpen(false)}
        >
          {t("delete")}
        </Button>
        <Button className="mainLinear" onClick={() => setOpen(false)}>
          {t("cancel")}
        </Button>
      </div>
    </div>
  );
};

export default DeleteActivity;
